import React, { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import AuthGuard from '../../components/auth/AuthGuard';
import ErrorBoundary from '../../components/common/ErrorBoundary';
// Page components are code-split (lazy); <Suspense> lives in AuthenticatedRoutes.jsx.
const StudentQuizList = lazy(() => import('../../pages/student/quizzes/StudentQuizList'));
const GroupPoll = lazy(() => import('../../pages/student/polls/GroupPoll'));
const QuizWarning = lazy(() => import('../../pages/student/quizzes/QuizWarning'));
const QuizStartHandler = lazy(() => import('../../pages/student/quizzes/QuizStartHandler'));
const QuizPlayer = lazy(() => import('../../pages/student/quizzes/QuizPlayer'));
const NotesHome = lazy(() => import('../../pages/student/notes/NotesHome'));
const NoteEditorPage = lazy(() => import('../../pages/student/notes/NoteEditorPage'));
const ResultView = lazy(() => import('../../pages/student/quizzes/ResultView'));

// The /student/* routes plus the final catch-all. Extracted VERBATIM
// (same order) from AuthenticatedRoutes' route table.
const studentRoutes = [
  { path: '/student/quizzes', element: (
    <AuthGuard>
      <StudentQuizList />
    </AuthGuard>
  ) },
  { path: '/student/group-poll', element: (
    <AuthGuard>
      <GroupPoll />
    </AuthGuard>
  ) },
  { path: '/student/assignments/:assignmentId/warning', element: (
    <AuthGuard>
      <QuizWarning />
    </AuthGuard>
  ) },
  { path: '/student/assignments/:assignmentId/start', element: (
    <AuthGuard>
      <QuizStartHandler />
    </AuthGuard>
  ) },
  { path: '/student/attempt/:attemptId', element: (
    <AuthGuard>
      <ErrorBoundary>
        <QuizPlayer />
      </ErrorBoundary>
    </AuthGuard>
  ) },
  { path: '/student/result/:attemptId', element: (
    <AuthGuard>
      <ErrorBoundary>
        <ResultView />
      </ErrorBoundary>
    </AuthGuard>
  ) },
  { path: '/student/notes', element: (
    <AuthGuard>
      <NotesHome />
    </AuthGuard>
  ) },
  { path: '/student/notes/new', element: (
    <AuthGuard>
      <NoteEditorPage />
    </AuthGuard>
  ) },
  { path: '/student/notes/:noteId', element: (
    <AuthGuard>
      <NoteEditorPage />
    </AuthGuard>
  ) },
  { path: '*', element: <Navigate to="/dashboard" replace /> },
];

export default studentRoutes;
